import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseData } from 'src/app/shared/models/api-response-data/ApiResponseData';
import { map, takeUntil, pluck } from 'rxjs/operators';
import { Observable, timer } from 'rxjs';
import { User } from 'src/app/shared/models/user/User';
import { COMPANY_ADDRESSBOOK_ID, CACHED_COMPANIES } from 'src/constants/local-storage-variables';
import { Company } from 'src/app/shared/models/company/Company';
import { DEFAULT_TAKE_UNTIL_TIME } from 'src/constants/times';
import { TicketService } from '../ticket/ticket.service';
import { ICompany } from 'src/app/shared/models/company/ICompany';
import { EnvironmentResolveService } from '../environment-resolve/environment-resolve.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  constructor(
    private http: HttpClient,
    private ticketService: TicketService,
    private erService: EnvironmentResolveService) {}

  // @info: returns current user with the Company Addressbook id
  public getCompanyAddressbook(currentUser: User): Observable<User> {
    const body = {
      application: 'ChangeHub',
      method: 'getRegistryData',
      parameters: {}
    };

    return this.http.post(this.erService.environmentERS.apiUrl, body).pipe(
      map((data: { companyContainers: any[] }) => {
        if (!data && !data.companyContainers && !data.companyContainers[0]) {
          return currentUser;
        }

        currentUser.companyAddressbookId = data.companyContainers[0].id;
        localStorage.setItem(COMPANY_ADDRESSBOOK_ID, data.companyContainers[0].id);

        this.cacheCompanies(currentUser.companyAddressbookId);
        this.ticketService.cacheTicketStatuses();

        // if (!currentUser.keepSignedIn) {
        //   localStorage.removeItem(ACCESS_TOKEN);
        // }

        return currentUser;
      })
    );
  }

  public cacheCompanies(companyAddressbookId: string): void {
    const body = {
      application: 'Addressbook',
      method: 'searchContacts',
      parameters: {
        filter: [
          {
            field: 'container_id',
            operator: 'in',
            value: [companyAddressbookId]
          }
        ],
        paging: {
          dir: 'DESC',
          start: 0,
          type: 'wTotalCount'
        }
      }
    };

    this.http
      .post(this.erService.environmentERS.apiUrl, body)
      .pipe(
        map((response: ApiResponseData<Company[]>) => {
          const companies: Company[] = response.results;
          localStorage.setItem(CACHED_COMPANIES, JSON.stringify(companies));
        }),
        takeUntil(timer(DEFAULT_TAKE_UNTIL_TIME))
      )
      .subscribe();
  }

  public getCompaniesFromCache(): Company[] {
    const companies: Company[] = JSON.parse(localStorage.getItem(CACHED_COMPANIES));

    return companies;
  }

  public getContacts(id: string): Observable<ICompany[]> {
    const body = {
      application: 'Admin',
      method: 'getUser',
      parameters: { id }
    };
    return this.http.post(this.erService.environmentERS.apiUrl, body).pipe(
      pluck('accountmanage', 'results'),
      map((items: { manage_id: ICompany }[]) =>
        items.map(item => ({
          id: item.manage_id.id,
          n_fn: item.manage_id.n_fn
        }))
      )
    );
  }
}
